import { useMutation } from '@tanstack/react-query';
import SuperFetch from '../../../lib/superFetch';
import { excelDownLoad } from '../../../lib/common';
import toastMsg from '../../../lib/toastMsg';

const useSellerListExcelDownload = (payload) => {
  return useMutation(
    ['exportSellers', payload],
    () => {
      return SuperFetch.post('/account/seller/list/excel/download', payload);
    },
    {
      onSuccess: (data) => {
        excelDownLoad('판매자리스트', data.data?.sellerListExcelSheet);
      },
      onError: (error) => {
        toastMsg.error(error.message);
      },
    },
  );
};

export default useSellerListExcelDownload;
